// @flow

import { createSelector } from 'reselect'

import { authenticatedUser$ } from 'fc-authenticated-user'

import {
  PROP_PARENT,
} from 'fc-model-users'

export default createSelector(
  [authenticatedUser$],
  function (user: Object): boolean {
    return !user[PROP_PARENT]
  }
)
